import { render, staticRenderFns } from "./Exercism.vue?vue&type=template&id=8075b0e2&scoped=true&"
import script from "./Exercism.vue?vue&type=script&lang=js&"
export * from "./Exercism.vue?vue&type=script&lang=js&"
import style0 from "./Exercism.vue?vue&type=style&index=0&id=8075b0e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8075b0e2",
  null
  
)

export default component.exports